import React, { useEffect, useState } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Typography,
  Box,
} from "@mui/material";
import { GraphQLClient } from "graphql-request";
import { graphqlEndpoint } from "../config";
import { UserRole } from "../constants/userRoles.ts";
import { READ_ADMINS } from "../graph/tenantRoles/queries";

const client = new GraphQLClient(graphqlEndpoint);


const AdminUserSelect = ({ selectedAdmin, setFieldValue, disabled = false }) => {
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAdmins = async () => {
      try {
        console.log("Fetching admins with role:", UserRole.ACCOUNT_MANAGER);

        const data = await client.request(READ_ADMINS, {
          role: UserRole.ACCOUNT_MANAGER,
        });

        console.log("Fetched admins:", data.readUsersByRole);

        setAdmins(data.readUsersByRole || []);
      } catch (err) {
        console.error("Failed to fetch admins", err);
        setError("Could not load admin users");
        setAdmins([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAdmins();
  }, []);
}

export default AdminUserSelect;
